import React, { useState,useEffect } from "react";
import "../../CSS/SignupLogin.css";
import { Button } from "react-bootstrap";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { IconButton } from "@mui/material";
import Spinner from "react-bootstrap/Spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../axios";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [windowInnerwidth, setWindowInnerWidth] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    function handleResize() {
    // console.log("window.innerWidth",window.innerWidth);
      setWindowInnerWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize)
    handleResize()
    return () => { 
      window.removeEventListener("resize", handleResize)
    }
  }, [setWindowInnerWidth])

  const showPasswordFun = () => {
    // console.log('hello')
    setShowPassword(!showPassword);
  };
  const submit = async () => {
    // console.log('email',email)
    // console.log('password',password)
    setLoading(true);
    if (!email || !password) {
      toast.error("Please fill in all fields", {
        toastId: 1,
      });
      setLoading(false);
      return;
    }
    try {
      const body = {
        email: email,
        password: password,
      };

      await axios.post("/user/login", body).then((res) => {
        // console.log("signup_post_res", res.data);
        localStorage.setItem("userInfo", JSON.stringify(res.data));
        navigate("/chats", { replace: true });
      });
      setLoading(false);
      toast.success("Login Successful", {
        toastId: 2,
      });
    } catch (error) {
      console.log("login_post_error_description", error.response.data);
      if (error.response.data === "InvalidUserEmailOrPassword") {
        toast.error("Invalid User Email or Password", {
          toastId: 3,
        });
      }
      // toast.error("Error while login. Try Again");
      setLoading(false);
    }
  };
  return (
    <>
      <div className="input_field">
        <label>Email<span style={{color:"red"}}>*</span></label>
        <input
          type="text"
          className="form-control"
          value={email}
          placeholder="Enter your email"
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div className="input_field">
        <label>Password<span style={{color:"red"}}>*</span></label>
        <input
          type={showPassword ? "text" : "password"}
          className="form-control"
          value={password}
          placeholder="Enter your password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <div className="icon_container">
          <IconButton onClick={showPasswordFun}>
            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
          </IconButton>
        </div>
      </div>

      <div className="button_container input_field">
        <Button variant="info" className="form-control" onClick={submit}>
          {/* Login */}
          {loading ? (
            <Spinner animation="border" variant="light" />
          ) : (
            <b>Login</b>
          )}
        </Button>
        <Button
          variant="dark"
          className="form-control"
          onClick={() => {
            // setEmail("guest@example.com");
            // setPassword("123456");
            // toast.warn("Warning: Data will lost after logout", {
            //   toastId: 4,
            //   autoClose:4000
            // });
            toast.warn("This feature will be available soon !", {
              toastId: 4,
              autoClose:4000
            });
          }}
        >
          Login as Guest
          {/* <b>Login as Guest</b> */}
        </Button>
      </div>
      <ToastContainer
        // position="bottom-center"
        position= {windowInnerwidth>500? "bottom-center" : "top-center"}
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
      />
    </>
  );
};

export default Login;
